import { TableSortFilterParams } from 'common/components/DataTable';
import { BlockStatus } from 'common/models';
import { GibbRate } from 'common/models/evaluation';
import { Market } from 'common/models/market';
import {
  getEnumLabels,
  getKeyFromEnumLabel,
  toEnumLabel,
} from 'utils/enumFunctions';
import { OrderOps, SearchOps } from './helpers';

export enum BlocksSortKeys {
  sizeKey = `${OrderOps.DESC}sizePercent`,
}

export enum BlocksFilterKeys {
  varietyKey = `variety${SearchOps.EQUALS}`,
  subVarietyKey = `subVariety${SearchOps.EQUALS}`,
  districtKey = `district${SearchOps.EQUALS}`,
  areaKey = `area${SearchOps.EQUALS}`,
  statusKey = `blockStatus${SearchOps.EQUALS}`,
  lotKey = `lotNumber${SearchOps.ICONTAINS}`,
  blockIdKey = `blockId${SearchOps.ICONTAINS}`,
  gibbKey = `gibb${SearchOps.EQUALS}`,
  gibbRateKey = `gibbRate${SearchOps.EQUALS}`,
  marketKey = `market${SearchOps.EQUALS}`,
  notesKey = `notes${SearchOps.EQUALS}`,
}

export const varietyFilter: TableSortFilterParams = {
  options: [],
  category: {
    key: BlocksFilterKeys.varietyKey,
    label: 'Variety',
  },
};

export const subVarietyFilter: TableSortFilterParams = {
  options: [],
  category: {
    key: BlocksFilterKeys.subVarietyKey,
    label: 'Sub-Variety',
  },
};

export const districtFilter: TableSortFilterParams = {
  options: [],
  category: {
    key: BlocksFilterKeys.districtKey,
    label: 'District',
  },
};

export const areaFilter: TableSortFilterParams = {
  options: [],
  category: {
    key: BlocksFilterKeys.areaKey,
    label: 'Area',
  },
};

export const blockStatusFilter: TableSortFilterParams = {
  options: getEnumLabels(BlockStatus).map(status => ({
    label:
      status === toEnumLabel(BlockStatus[BlockStatus.No_Status])
        ? `(${status})`
        : status,
    value: getKeyFromEnumLabel(BlockStatus, status)?.toString() || '-1',
  })),
  category: {
    key: BlocksFilterKeys.statusKey,
    label: 'Block Status',
  },
};

export const blockIdFilter: TableSortFilterParams = {
  options: [],
  category: {
    key: BlocksFilterKeys.blockIdKey,
    label: 'Block ID',
  },
};

export const lotFilter: TableSortFilterParams = {
  options: [],
  category: {
    key: BlocksFilterKeys.lotKey,
    label: 'Lot #',
  },
};

export const gibbFilter: TableSortFilterParams = {
  options: [
    [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ],
  ],
  category: {
    key: BlocksFilterKeys.gibbKey,
    label: 'Gibb',
  },
  singleSelect: true,
};

export const gibbRateFilter: TableSortFilterParams = {
  options: getEnumLabels(GibbRate)
    .filter(rate => rate !== GibbRate[GibbRate.None])
    .map(rate => ({
      label: rate,
      value: getKeyFromEnumLabel(GibbRate, rate)?.toString() || '-1',
    })),
  category: {
    key: BlocksFilterKeys.gibbRateKey,
    label: 'Gibb Rate',
  },
};

export const marketFilter: TableSortFilterParams = {
  options: Object.values(Market).map(market => ({
    label: market,
    value: market,
  })),
  category: {
    key: BlocksFilterKeys.marketKey,
    label: 'Market',
  },
};

export const notesFilter: TableSortFilterParams = {
  options: [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ],
  category: {
    key: BlocksFilterKeys.notesKey,
    label: 'Notes',
  },
  singleSelect: true,
};

export const sizeSort: TableSortFilterParams = {
  options: [],
  category: {
    key: BlocksSortKeys.sizeKey,
    label: 'Size',
  },
  singleSelect: true,
};
